module.exports = __webpack_public_path__ + "img/apply-tips.19b92072.png";